import { Box } from '@mui/material';
import { FC } from 'react';
import { Page } from '../page';

type Props = {
  stickyThresholdSize?: number;
  leftColumn?: JSX.Element;
  rightColumn?: JSX.Element;
  leftMinWidth?: string;
  rightMinWidth?: string;
};

export const PageWithSidebar: FC<React.PropsWithChildren<Props>> = ({
  stickyThresholdSize,
  leftColumn,
  rightColumn,
  leftMinWidth = 320,
  rightMinWidth = 320,
  children
}) => {
  stickyThresholdSize = stickyThresholdSize ?? 32;
  return (
    <Page>
      <Box
        display={'flex'}
        gap={4}
        sx={{
          height: '100%',
          flexWrap: {
            md: 'unset',
            sm: 'wrap'
          }
        }}
      >
        {leftColumn && (
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              flexDirection: 'column',
              flexBasis: leftMinWidth,
              minWidth: leftMinWidth,
              height: '100%',
              flexGrow: 1,
              position: 'sticky',
              top: stickyThresholdSize,
              alignSelf: 'flex-start',
              gap: '24px'
            }}
          >
            {leftColumn}
          </Box>
        )}
        <Box
          sx={{
            height: '100%',
            flexBasis: '320px',
            flexGrow: 999,
            minWidth: 0,
            overflow: 'hidden'
          }}
        >
          {children}
        </Box>
        {rightColumn && (
          <Box
            sx={{
              display: 'flex',
              flexBasis: rightMinWidth,
              minWidth: rightMinWidth,
              height: '100%',
              flexGrow: 1,
              position: 'sticky',
              top: stickyThresholdSize,
              alignSelf: 'flex-start',
              flexDirection: 'column',
              gap: '24px'
            }}
          >
            {rightColumn}
          </Box>
        )}
      </Box>
    </Page>
  );
};
